import { render } from "./CountryCodeModal.vue?vue&type=template&id=56d63d3d&scoped=true"
import script from "./CountryCodeModal.vue?vue&type=script&lang=js"
export * from "./CountryCodeModal.vue?vue&type=script&lang=js"

import "./CountryCodeModal.vue?vue&type=style&index=0&id=56d63d3d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56d63d3d"]])

export default __exports__